import styles from "./team.module.css";
import Teamcard from "./teamcard";
import team from "./team";

const Teamsection = () =>{
    return (
        <section className={styles.teamsection}>
            <h2 className={styles.heading}>
                <span className={styles.heading1}>MEET OUR </span>
                <span className={styles.heading2}>TEAM</span>
            </h2>
            <p className={styles.description1}>
                The people behind TEDxIITGuwahati
            </p>
            {/* <p className={styles.description2}>
                We are driven by passion and curiosity. We are inspired by ideas. And we want to leave 
                the world better than we found it. In our daily lives you can find us working in design,
                computer science, chemistry, biology, finance, NGOs, arts, business, psychology, health and 
                everything in between. We work year round to bring TEDxIITGuwahati and all of our
                activities to life.
            </p> */}

            <div className={styles.grid}>
                {team.map((member) => (
                    <Teamcard
                        key={member.id}
                        name={member.name}
                        role={member.role}
                        image={member.image}
                        linkedin={member.linkedin}
                    />

                ))}
            </div>
        </section>
    );
};

export default Teamsection;